import { useDispatch, useSelector } from "react-redux"
import AnimatedPage from "../components/animatedPage"
import Banner from "../components/campusLife/banner"
import CampusLifeTabs from "../sections/campusLifeTabs"
import CampusLocation from "../sections/campusLocation"
import { useEffect } from "react"
import { fetchCampusLifeData } from "../redux/slice/campusLifePage"

const CampusLife = () => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(fetchCampusLifeData("campus"))
    }, [dispatch])
    const state = useSelector(state => state.campusLife)
   
    const campusLife = state?.data?.properties
    const name = campusLife?.pageTitle
    const img = campusLife?.backgroundImage !== null ? campusLife?.backgroundImage[0]?.url : ""
    return (
        <AnimatedPage>
            {/* <ScrollToTop /> */}
            <Banner name={name} img={img} />
            <CampusLocation />
            <CampusLifeTabs />
        </AnimatedPage>
    )
}

export default CampusLife